import React from 'react';

import { FormControl, ToggleButton } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from 'react-redux';
import { uploadTraitStrengthMapping } from '../../redux/slices/onboarding/onboardingThunk';
import { setPreviousAnswers, setQuestionnaire } from '../../redux/slices/onboarding/onboardingSlice';

const RadioButtonQuestion = ({ pInd, qInd, answer }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { questionnaire, previousAnswers } = useSelector(state => state.onboarding);

    //Handle the radio button change
    const onRadioChanged = async (e) =>{
        e.preventDefault();
        //If user just clicked the selected radio button, unselect it
        const tempPreviousAnswers = JSON.parse(JSON.stringify(previousAnswers));
        const tempQuestionnaire = JSON.parse(JSON.stringify(questionnaire));

        const tempQuestion = tempQuestionnaire[pInd].SurveyQuestions[qInd];
        const tempAnswer = tempQuestion.AnswerChoices.find((tempAnswer) => tempAnswer.id === answer.id);
        
        if(!tempAnswer) {
            console.log("Error: Answer not found in questionnaire");
            return;
        }

        tempQuestion.AnswerChoices?.forEach((otherAnswer) => {
            tempPreviousAnswers[otherAnswer.id] = false;
            otherAnswer.selected = false;
        });

        tempAnswer.selected = true;
        tempPreviousAnswers[tempAnswer.id] = true;
        
        dispatch(setPreviousAnswers(tempPreviousAnswers));
        dispatch(setQuestionnaire(tempQuestionnaire));
        dispatch(uploadTraitStrengthMapping({ previousAnswers: tempPreviousAnswers, questionnaire: tempQuestionnaire, pageIndex: pInd }));
    }

    return (
        <FormControl
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                maxWidth: "40rem",
                width: "100%",
                minWidth: "20rem"
            }}
        >
            <ToggleButton
                key={answer.id}
                selected={previousAnswers[answer.id]}
                onClick={async (e) => await onRadioChanged(e, answer.id)}
                sx={{
                    margin: "0.5rem",
                    backgroundColor: theme.palette.caralystRed.dark,
                    width: '40vw',
                    minWidth: "18rem",
                    maxWidth: "25rem",
                    color: "white",
                    transition: "background-color 0.15s ease-in-out",
                    textTransform: "none",
                    fontSize: "1.2em",
                    '&:hover': {
                        backgroundColor: theme.palette.caralystRed.main,
                        color: "white",
                    },
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.caralystRed.main,
                        color: "white",
                    },
                    '&.Mui-selected:hover': {
                        backgroundColor: theme.palette.caralystRed.main,
                        color: "white",
                    }
                }}
            >
                {answer.text}
            </ToggleButton>
        </FormControl>
    );
}

export default RadioButtonQuestion;